import FavButtons from './favButtons'

export default FavButtons
